import axios from 'axios'
// Default object returns a list of available locales
export default ['en', 'fr', 'ko', 'es']

export function getLocales () {
  return axios.get('/locales.json').then(res => res.data || [])
}
